import { cmContractTotalAmount, fmtCmSvcMoney } from '@lib/cmServices';
import type { ModalFormState } from '@app/modal-form-types';
import { formField } from '@app/modal-form-types';

export default function CmPaymentSummary({ form }: { form: ModalFormState }) {
  const totalContract = cmContractTotalAmount(form);
  const paidOverall = formField(form, 'paidAmount');
  const paidRem = formField(form, 'paidRemuneration');
  const paidReimb = formField(form, 'paidReimbursable');

  return (
    <div className="cm-payment-summary" style={{ gridColumn: '1 / -1' }}>
      <div className="cm-form-sec-title">Payment Summary</div>
      <div className="cm-payment-summary-grid">
        <div className="cm-payment-summary-item">
          <span className="cm-payment-summary-label">Total Contract Amount</span>
          <strong className="cm-payment-summary-value">{fmtCmSvcMoney(totalContract)}</strong>
        </div>
        <div className="cm-payment-summary-item">
          <span className="cm-payment-summary-label">Total Amount Paid</span>
          <strong className="cm-payment-summary-value">{fmtCmSvcMoney(paidOverall)}</strong>
        </div>
        <div className="cm-payment-summary-item">
          <span className="cm-payment-summary-label">Amount Paid (Remuneration)</span>
          <strong className="cm-payment-summary-value">{fmtCmSvcMoney(paidRem)}</strong>
        </div>
        <div className="cm-payment-summary-item">
          <span className="cm-payment-summary-label">Amount Paid (Reimbursable)</span>
          <strong className="cm-payment-summary-value">{fmtCmSvcMoney(paidReimb)}</strong>
        </div>
      </div>
    </div>
  );
}
